export default {
  data() {
    return {
      localizedNutrients: [
        {
          key: 'calories',
          value: 'message.nutrientCalories'
        },
        {
          key: 'protein',
          value: 'message.nutrientProtein'
        },
        {
          key: 'carbohydrate',
          value: 'message.nutrientCarbohydrate'
        },
        {
          key: 'fat',
          value: 'message.nutrientFat'
        },
        {
          key: 'sugar',
          value: 'message.nutrientSugar'
        },
        {
          key: 'saturated_fat',
          value: 'message.nutrientSaturatedFat'
        },
        {
          key: 'monounsaturated_fat',
          value: 'message.nutrientMonounsaturatedFat'
        },
        {
          key: 'polyunsaturated_fat',
          value: 'message.nutrientPolyunsaturatedFat'
        },
        {
          key: 'cholesterol',
          value: 'message.nutrientCholesterol'
        },
        {
          key: 'fibre',
          value: 'message.nutrientFibre'
        },
        {
          key: 'sodium',
          value: 'message.nutrientSodium'
        },
        {
          key: 'potassium',
          value: 'message.nutrientPotassium'
        }
      ]
    }
  },
  methods: {
    localizeNutrient(key) {
      let self = this;
      return self.localizedNutrients.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/FoodNutrients/NutrientLocalizer.js